









import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component({})
export default class SidebarNavDropdown extends Vue {
  @Prop({ default: "" })
  public name: string;

  @Prop({ default: "" })
  public url: string;

  @Prop({ default: "" })
  public icon: string;

  @Emit()
  public handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle("open");
  }
}
